export const IMAGE_QUALITY = Object.freeze({
  OK: "ok",
  LOW: "low",
  TOO_SMALL: "too-small",
});

/* Mirrors server/domain/products/imageQuality.js; the thresholds themselves come from
 * /api/productType/list, so only the comparison is repeated here. */
export const qualityOf = ({ requirements, width, height }) => {
  const shorterSide = Math.min(width, height);

  return shorterSide < requirements.minImageDimension
    ? IMAGE_QUALITY.TOO_SMALL
    : shorterSide < requirements.recommendedImageDimension
    ? IMAGE_QUALITY.LOW
    : IMAGE_QUALITY.OK;
};

const fitCanvasOf = ({ width, height, aspectRatio }) =>
  width / height > aspectRatio
    ? { width, height: Math.ceil(width / aspectRatio) }
    : { width: Math.ceil(height * aspectRatio), height };

export const outputSizeOf = ({ mode, crop, natural, aspectRatio }) =>
  mode === "fit"
    ? fitCanvasOf({ ...natural, aspectRatio })
    : { width: crop.width, height: crop.height };

const OPAQUE = 128;
const WHITE = "#ffffff";

const range = (length) => Array.from({ length }, (_, index) => index);

const borderOffsets = (width, height) =>
  [
    ...new Set([
      ...range(width).map((x) => x),
      ...range(width).map((x) => (height - 1) * width + x),
      ...range(height).map((y) => y * width),
      ...range(height).map((y) => y * width + width - 1),
    ]),
  ].map((index) => index * 4);

const hex = (channel) => Math.round(channel).toString(16).padStart(2, "0");

const averageColour = ({ data, offsets }) =>
  `#${[0, 1, 2]
    .map((channel) =>
      hex(
        offsets.reduce((sum, offset) => sum + data[offset + channel], 0) /
          offsets.length,
      ),
    )
    .join("")}`;

/* `data` is a canvas ImageData buffer: RGBA bytes, row by row. */
export const edgeColourOf = ({ data, width, height }) => {
  const opaque = borderOffsets(width, height).filter(
    (offset) => data[offset + 3] >= OPAQUE,
  );

  return opaque.length === 0 ? WHITE : averageColour({ data, offsets: opaque });
};

export const moveForDrop = ({ ids, activeId, overId }) =>
  [null, undefined, activeId].includes(overId)
    ? null
    : { from: ids.indexOf(activeId), to: ids.indexOf(overId) };
